import { black3, evisortBlue } from '../../../assets/shared-styles/general';

const styles = {
  ecFilterField: {
    display: 'flex',
    alignItems: 'center',
  },
  removeFieldContainer: {
    marginRight: '8px',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
  },
  fieldContainer: {
    width: '240px',
  },
  fieldContainerError: {
    width: '240px',
    '& .react-datepicker__input-container > input': {
      border: '1px solid #f33737',
    },
  },
  blueLine: {
    width: '16px',
    border: 0,
    borderTop: `2px solid ${evisortBlue}`,
    margin: 0,
  },
  valuesContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  multipleValuesContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '12px 0 0 28px',
    '& svg': {
      flexShrink: 0,
    },
  },
  multipleValues: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    minHeight: '30px',
    marginLeft: '8px',
  },
  multipleValuesEmpty: {
    color: black3,
    fontSize: '15px',
  },
  horizontalAndSeparator: {
    margin: '0 8px',
    color: black3,
    fontSize: '15px',
  },
};

export default styles;
